import React from 'react'
import PageLayout from '../../../components/layouts/PageLayout'
import Map from '../../../components/Map'

export const View = props => {
	return <PageLayout>
		<div className='c-content'>
			<Map />
		</div>
	</PageLayout>
}

export default View



// WEBPACK FOOTER //
// ./src/routes/Location/components/View.js